import React, { useEffect, useState } from 'react';

const isServerSide = typeof window === 'undefined';

export const WithConditionalHydration =
  (Component, condition) =>
  ({ ...props }) => {
    const [isHydrated, setIsHydrated] = useState(false);

    useEffect(() => {
      if (condition(props) === true) {
        // If "Component" is lazy-loadable, load it before hydrating it.
        if (Component.load) {
          Component.load().then(() => setIsHydrated(true));
        } else {
          setIsHydrated(true);
        }
      }
    }, []);

    if (isHydrated || isServerSide) {
      return <Component {...props} />;
    }

    return null;
  };
